<div *ngIf="isVisible" [class]="containerClass" [helpTarget]="helpTarget">
  <i class="pi pi-times cross-icon" (click)="close.emit()"></i>
  <div class="mb-3 d-flex align-items-center justify-content-between">
    <p class="f-16 mb-0">Follow up</p>
    <button type="button" class="follow-up-settings" pTooltip="Customise Follow Up" tooltipPosition="left" (click)="openEditor()">
      <i class="pi pi-cog f-12"></i>
    </button>
  </div>
  <div>
    <div
      *ngFor="let item of menuItems; trackBy: trackById"
      class="mb-1 d-flex align-items-center justify-content-between cursor-pointer"
      (click)="onQuickFollowUp(item)">
      <p class="f-14 follow-up-label" [ngClass]="{ 'like-dislike': activeOptionId === item.id }">{{ item.label }}</p>
      <p class="f-14 text-nowrap" [ngClass]="{ 'like-dislike': activeOptionId === item.id }">
        {{ item.display }}
      </p>
    </div>

    <hr *ngIf="menuItems.length" />

    <!-- Always offered, whatever the agent's presets — the only way to book an arbitrary date. -->
    <div class="text-center cursor-pointer" (click)="togglePickDate.emit()">
      <p><i class="pi pi-calendar-plus"></i> Pick date & time</p>
    </div>

    <div *ngIf="isPickDate" class="mt-3 tim_e">
      <div class="row">
        <div class="col-sm-7">
          <p-calendar
            (onSelect)="dateSelected.emit($event)"
            [minDate]="minSelectableDate"
            [ngModelOptions]="{ standalone: true }"
            placeholder="Pick Date"
            dateFormat="dd/mm/yy"
            [firstDayOfWeek]="1">
          </p-calendar>
        </div>

        <div class="col-sm-5 pl-0">
          <ng-select
            [items]="timerOptions"
            bindLabel="label"
            bindValue="value"
            [searchable]="true"
            placeholder="Select Time"
            [clearable]="true"
            id="type"
            (change)="timeChanged.emit()"
            name="type"
            [ngModel]="followUpTime"
            (ngModelChange)="followUpTimeChange.emit($event)">
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Outside the menu's *ngIf on purpose: clicking inside the dialog counts as a click outside the
     menu, which closes it, and the dialog must survive that. -->
<app-follow-up-options-editor [(isVisible)]="isEditorOpen"></app-follow-up-options-editor>
